module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAATCAYAAACdkl3yAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADUSURBVHgB3VLREYIwDE05BmAEnMC6AW6gE4gTiBPYDXADHcENcAPdQEdgg/qi4S5XTxCOL95deGmT95oCRJOF8d6n4BKR0HCsYzxSxEptXuk/WHW4JUyU+Q8q4RPi53Rckx7GTTjTRsxO8odcOTSxUmMUWhvpRmOMA81kyYJCmexAlSwX6D1qbRyeioYnREukDlEin0spR1wQW/TUoe7LqDFjIUyYD7K9D6foNFKG/M7OSBPk97beViM1XSciGgmjGemrbd4/Vj+k2qj5lDkNR03TxQv6R4oJ+HMt4gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_gz_em.png
// module id = Fk5C
// module chunks = 15